/**
 * 创建人：王靖
 * 时间：2019-6-14
 * 描述：为树形组件提供功能的服务:创建和销毁组件的服务
 * 更新记录: 
 */
import { Injectable} from "@angular/core";
import { SwTreeNodeOptions } from "./sw-tree-node/sw-tree-node";

@Injectable()
export class SwTreeService {

  /**
   * 将平级数据转化为树数据, datas：要转化为树结构的原始数据, keySelected选中节点的key值
   * @param datas  数据源
   * @param keySelected  选中的节点的key
   * @param id  主键
   * @param pid  父主键
   * @param text  显示字段
   * @param disabledNodeId 禁用字段 
   * @param OpenNode  默认展开节点
   * @param selectChildren  最底层节点带复选框功能是否开启
   * @param allCanCheck  所有节点带复选框功能是否开启
   * @param multiNodeIds  复选功能的选中节点的id
   * @param type  节点类型,来决定图标类型
   * @param initSelectedId  单选功能默认回显的节点 id, 或者是 'default'默认选中不为只读或禁用的第一个节点
   */
  toNodeOptions(datas: any[], keySelected: string,id:string,pid:string,text:string,disabledNodeId:string,readonlyNodeId:any[],readonlySelfId:any[],OpenNode?:number,selectChildren?:boolean,allCanCheck?:boolean,multiNodeIds?:any[],type?:string,initSelectedId?:string,isPid0?:boolean): SwTreeNodeOptions[]{
   
    let nodes:SwTreeNodeOptions[] = [];
    let num:number = 0;
    let index:number =0;
    for (let data of datas) {
      if (datas.filter(d => d[id] === data[pid]).length == 0 && (isPid0 && data[pid] == '0' || !isPid0)) { //判断该节点是否有父级，没父级则添加为根节点。
        if(disabledNodeId){  //如果要禁止的数据没有父节点,就不展示此根节点
          let array = disabledNodeId.split(',');//将禁止的节点id字符串 分割为数组
          if(array.indexOf(data[id])!= -1){
            continue
          }
        }
        nodes.push(new SwTreeNodeOptions());
        nodes[num].key = data[id];
        nodes[num].title = data[text];
        nodes[num].data = data;
        let t = data[type] ? 2 : 1
        nodes[num].iconType = t;
        nodes[num].parent = null  //根节点的parent设置为null
        
        if(readonlyNodeId.length){  //如果要只读的数据没有父节点,就设置readonly = true;
          if(readonlyNodeId.indexOf(data[id])!= -1 || readonlyNodeId.indexOf(data[pid])!= -1){
            nodes[num].readonly = true;
            nodes[num].readonlyFrom = 'readonlyNodeId';
          }
        }

        if(readonlySelfId.length){  //如果要只读的数据没有父节点,就设置readonly = true;
          if(readonlySelfId.indexOf(data[id])!= -1){
            nodes[num].readonly = true;
            nodes[num].readonlyFrom = 'readonlySelfId';
          }
        }

        //如果要最底层节点带有复选框
        if(selectChildren){
          nodes[num].multiple = true;
        }
        //如果要所有节点带有复选框
        if(allCanCheck){
          nodes[num].checkbox = true;
          nodes[num].parent = data[pid];  //将上级数据的id存进去
        }
        //如果有已经选中的复选数据
        if(multiNodeIds && multiNodeIds.length){  //如果已经选中的数据有父节点
          nodes[num].selected = multiNodeIds.indexOf(data[id])!= -1
        }
        if(OpenNode){
          if(num <= OpenNode-1)
          nodes[num].expanded = true;
        }else{
          nodes[num].expanded = data.expanded;
        }
        //如果有单选功能的默认回显功能
        if(!allCanCheck && !selectChildren && !multiNodeIds.length && initSelectedId){
          //如果是默认选中最上的没有禁用和只读的节点
          if(!nodes[num].readonly && !nodes[num].disabled && initSelectedId == 'default'){
            nodes[num].selected = true
            //如果已经选中了节点,那么下面的循环中不再勾选, 将 selectedId 置空
            initSelectedId = ""
          } else if(!nodes[num].readonly && !nodes[num].disabled && initSelectedId && initSelectedId != 'default'){
            //如果是传入一个 id 进来
            if(initSelectedId == nodes[num].key){
              nodes[num].selected = true
            }
          }
        }

        num++;
      }
    }
    for (let node of nodes) {
      //依次为节点添加子节点， node:节点
      node.children = this.addNodeChildren(datas, node, keySelected,id,pid,text,disabledNodeId,readonlyNodeId,readonlySelfId,OpenNode,index,selectChildren,allCanCheck,multiNodeIds,type,initSelectedId);
    }
    return nodes;
  }

  /**
   * 添加子节点，datas：要转化为树结构的原始数据, keySelected选中节点的key值，node:节点
   * @param datas  数据源
   * @param node  当前节点数据
   * @param keySelected  选中节点的key 单选功能默认回显的节点 id, 或者是 'default'默认选中不为只读或禁用的第一个节点
   * @param disabledNodeId  禁用的数据(该节点及其子节点不展示)
   * @param readonlyNodeId  只读的数据(该节点及其子节点展示但不能选择)
   * @param readonlySelfId  只读的数据(该节点展示但不能选择)
   * @param OpenNode  默认展开
   * @param index  当前第几节点
   * @param selectChildren  是否开启最底层节点多选功能
   * @param allCanCheck  是否开启所有节点多选功能
   * @param multiNodeIds  多选功能选中的节点的id(回显)
   * @param type  节点类型,来决定图标类型
   * @param initSelectedId  单选功能默认回显的节点 id, 或者是 'default'默认选中不为只读或禁用的第一个节点
   */
  addNodeChildren(datas: any[], node: SwTreeNodeOptions, keySelected: string,id:string,pid:string,text:string, disabledNodeId:string,readonlyNodeId:any[],readonlySelfId:any[],OpenNode?:number,index?:number,selectChildren?:boolean,allCanCheck?:boolean,multiNodeIds?:any[],type?:string,initSelectedId?:string): SwTreeNodeOptions[]{
    let num = 0;    //子集索引位置
    index++;
    node.children = [];
    for (let data of datas.filter(d => d[pid] == node.key)) {  //找出所有当前节点的子节点， 
      if(disabledNodeId){
        let array = disabledNodeId.split(',');//将禁止的节点id字符串 分割为数组
        if(array.indexOf(data[id])!= -1){
          continue
        }
      }
    
      // if(data[id] == disabledNodeId){
      //   continue
      // }
      node.children.push(new SwTreeNodeOptions());  //为当前节点添加子节点数据   
      if (keySelected != "" && keySelected == data[id]){  //当前节点为选中的节点 
        node.expanded = true;   //展开选中节点的父节点  
        node.halfSelected = true  //父节点为半选
        node.children[num].selected = true;  //当前节点设置为选中   
      }    
      node.children[num].key = data[id];         //id值
      node.children[num].data = data;
      let t = data[type] ? 2 : 1
      node.children[num].iconType = t;
      node.children[num].title = data[text];       //显示的文本值
      node.children[num].parent = node.key;       //设置当前子节点的父节点的id
      if(readonlyNodeId.length){  //如果要只读的数据没有父节点,就不展示此根节点
        //如果该节点的id或者是父级的id是只读,或者是父级节点已经设置为只读(由 readonlyNodeId 设置的),那么这个子节点就是只读
        if(readonlyNodeId.indexOf(data[id])!= -1  || readonlyNodeId.indexOf(data[pid])!= -1 || (node.readonly && node.readonlyFrom == 'readonlyNodeId')){
          node.children[num].readonly = true
        }
      }

      if(readonlySelfId.length){  //如果要只读的数据没有父节点,就不展示此根节点
        //如果该节点的id在数组中,那么这个子节点就是只读
        if(readonlySelfId.indexOf(data[id])!= -1){
          node.children[num].readonly = true
        }
      }

      //如果要最底层节点带有复选框
      if(selectChildren){
        node.children[num].multiple = true;
        if(multiNodeIds && multiNodeIds.length){  //如果已经选中的数据
          if(multiNodeIds.indexOf(data[id])!= -1){  //如果当前子节点已经被选中
            node.children[num].selected = true;  //将此节点设置为选中
            //且将选中节点的父节点展开
            node.expanded = true
          }
        }
      }
       //如果要所有节点带有复选框
       if(allCanCheck){
        node.children[num].checkbox = true;
        node.children[num].parent = data[pid];  //将上级数据的id存进去
        if(multiNodeIds && multiNodeIds.length){  //如果已经选中的数据
          if(multiNodeIds.indexOf(data[id])!= -1 || multiNodeIds.indexOf(data[pid])!= -1 || node.selected){  //如果当前子节点已经被选中或者是他的父节点已经被选中
            node.children[num].selected = true;  //将此节点设置为选中
            //且将选中节点的父节点展开
            node.expanded = true 
          }
        }
      }

      if(OpenNode){
        if(index <= OpenNode-1)
        node.children[num].expanded =  true;
      }else{
        node.children[num].expanded = data.expanded;   
      }

      //如果有单选功能的默认回显功能
      if(!allCanCheck && !selectChildren && !multiNodeIds.length && initSelectedId){
        //如果是默认选中最上的没有禁用和只读的节点
        if(!node.children[num].readonly && !node.children[num].disabled && initSelectedId == 'default'){
          node.children[num].selected = true
          //如果已经选中了节点,那么下面的循环中不再勾选, 将 initSelectedId 置空
          initSelectedId = ""
          
        } else if(!node.children[num].readonly && !node.children[num].disabled && initSelectedId && initSelectedId != 'default'){
          //如果是传入一个 id 进来
          if(initSelectedId == node.children[num].key){
            node.children[num].selected = true
          }
        }
      }

      node.children[num].children = this.addNodeChildren(datas, node.children[num], keySelected,id,pid,text, disabledNodeId,readonlyNodeId,readonlySelfId,OpenNode,index,selectChildren,allCanCheck,multiNodeIds); //递归为子节点继续添加子节点
      if (keySelected != "" && node.children[num].expanded == true){  //将所有展开节点的父节点都展开
        node.expanded = true; 
        node.halfSelected = true 
      }  
           

      num++;
    }
    return node.children;
  }
  
}